import styled from 'styled-components'
const COLORS = [
  '#336699',
  '#909000',
  '#CCCCCC',
  '#8ecae6',
  '#219ebc',
  '#023047',
  '#ffb703',
  '#fb8500',
  '#ffbe0b',
  '#fb5607',
  '#ff006e',
  '#8338ec',
  '#3a86ff',
  '#780000',
  '#c1121f',
  '#fdf0d5',
  '#003049',
  '#669bbc',
  '#660708',
  '#a4161a',
  '#ba181b',
  '#e5383b',
  '#f5f3f4',
  '#cdb4db',
  '#ffc8dd',
  '#ffafcc',
  '#bde0fe',
  '#a2d2ff',
  '#ff6700',
  '#ebebeb',
  '#c0c0c0',
  '#3a6ea5',
  '#004e98',
  '#5f0f40',
  '#9a031e',
  '#fb8b24',
  '#e36414',
  '#0f4c5c'
]

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 120px;
`

const Tile = styled.div`
  ${({ background }) => `
  width: 20px;
  height: 20px;
  background: ${background};
`}
`

export const Palette = ({ onChange }) => {
  const select = (color) => {
    onChange(color)
  }
  return (
    <Container>
      {COLORS.map((color) => (
        <Tile
          key={color}
          width={20}
          height={20}
          onClick={() => select(color)}
          background={color}
        />
      ))}
    </Container>
  )
}
